// src/App.jsx
import React from "react";


function Ugstudents() {

    const alumniList = [
        { sno: 1, name: "Prashant Singh", department: "Mechanical", batch: 2020 },
        { sno: 2, name: "Balbir Singh", department: "Mechanical", batch: 2020 },
        { sno: 3, name: "Manish Goyal", department: "Mechanical", batch: 2020 },
        { sno: 4, name: "Joshil Kumar", department: "Biomedical", batch: 2020 },
        { sno: 5, name: "Aditi Kumari", department: "Mechanical", batch: 2019 },
        { sno: 6, name: "Boga Sainath", department: "Mechanical", batch: 2019 },
        { sno: 7, name: "Addepalli Konda Shyam Siddharth", department: "Mechanical", batch: 2019 },
        { sno: 8, name: "Kuldeep", department: "Mechanical", batch: 2019 },
        { sno: 9, name: "Saurav Kumar", department: "Mechanical", batch: 2019 },
        { sno: 10, name: "Guggilla Venugopal", department: "Mechanical", batch: 2019 },
        { sno: 11, name: "Boda Ramalingaiah", department: "Mechanical", batch: 2018 },
        { sno: 12, name: "Navneet Kumar", department: "Mechanical", batch: 2017 },
        { sno: 13, name: "Shivam", department: "Mechanical", batch: 2017 },
        { sno: 14, name: "Sushil Kumar", department: "Biomedical", batch: 2017 },
        { sno: 15, name: "Bharat Yadav", department: "Mechanical", batch: 2016 },
        { sno: 16, name: "Neetesh Kumar Dubey", department: "Mechanical", batch: 2015 },
        { sno: 17, name: "Namrata Patil", department: "Mechanical", batch: 2015 }
      ];
      

    return (
        <div className="min-h-screen overflow-x-auto p-4 font-serif">
                        <h2 className="text-1xl p-4">M.Tech Students Details:</h2>

            <table className="min-w-full bg-white border border-gray-300">
                <thead className="bg-gray-200">
                    <tr>
                        <th className="px-4 py-2 border-b">S.No.</th>
                        <th className="px-4 py-2 border-b">Funding Agency</th>
                        <th className="px-4 py-2 border-b">Title of Project</th>
                        <th className="px-4 py-2 border-b">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {alumniList.map((stl) => (
                        <tr key={stl.sno} className="hover:bg-gray-100">
                            <td className="px-4 py-2 border-b text-center">{stl.sno}</td>
                            <td className="px-4 py-2 border-b">{stl.name}</td>
                            <td className="px-4 py-2 border-b">{stl.department}</td>
                            <td className="px-4 py-2 border-b text-center">{stl.batch}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Ugstudents;